import { render, staticRenderFns } from "./ItemList_List.vue?vue&type=template&id=da447c64&"
import script from "./ItemList_List.vue?vue&type=script&lang=js&"
export * from "./ItemList_List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports